export default "__VITE_ASSET__B42e2Jn0__"